import * as React from "react";

import { Well } from "react-bootstrap";

type Props = {
    className?: string;
    icon?: string;
    backgroundClassName?: string;
    children?: React.ReactNode;
};

export const MinOrderQuantityPanel = ({ className = "", backgroundClassName = " ", icon, children }: Props) => (
    <div className={"mfcss_moq-panel " + className}>
        <Well className={"well-sm " + backgroundClassName}>
            {icon && (
                <div className="mfcss_moq-panel-icon">
                    <i className={icon} />
                </div>
            )}
            <div className="mfcss_moq-panel-content">{children}</div>
        </Well>
    </div>
);
